export default __webpack_public_path__ + "static/media/g2021-7.b2b02279.jpeg";